import { ScrollLink } from "@/components/ui/scroll-link";
import { XLogo } from "@/components/icons/x-logo";
import { BitcoinLogo } from "@/components/icons/bitcoin-logo";

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container py-8">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="space-y-4">
            <ScrollLink to="/" className="flex items-center gap-2">
              <div className="rounded-full">
                <BitcoinLogo className="h-8 w-8" />
              </div>
              <span className="font-display font-bold text-xl">Bitcoiner Books</span>
            </ScrollLink>
            <p className="text-sm text-muted-foreground">
              Discover books recommended by prominent Bitcoin thought leaders. Your gateway to Bitcoin knowledge and wisdom.
            </p>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Navigation</h3>
            <ul className="space-y-2">
              <li>
                <ScrollLink 
                  to="/books" 
                  className="text-sm text-muted-foreground hover:text-primary"
                >
                  Books
                </ScrollLink>
              </li>
              <li>
                <ScrollLink 
                  to="/authors" 
                  className="text-sm text-muted-foreground hover:text-primary"
                >
                  Authors
                </ScrollLink>
              </li>
              <li>
                <ScrollLink 
                  to="/people" 
                  className="text-sm text-muted-foreground hover:text-primary"
                >
                  People
                </ScrollLink>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <ScrollLink 
                  to="/privacy" 
                  className="text-sm text-muted-foreground hover:text-primary"
                >
                  Privacy Policy
                </ScrollLink>
              </li>
              <li>
                <ScrollLink 
                  to="/terms" 
                  className="text-sm text-muted-foreground hover:text-primary"
                >
                  Terms of Service
                </ScrollLink>
              </li>
              <li>
                <ScrollLink 
                  to="/disclaimer" 
                  className="text-sm text-muted-foreground hover:text-primary"
                >
                  Disclaimer
                </ScrollLink>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Social</h3>
            <div className="flex space-x-4">
              <a
                href="https://twitter.com/bitcoinerbooks"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary"
              >
                <XLogo className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 border-t pt-8 text-center">
          <p className="text-sm text-muted-foreground">
            © {currentYear} Bitcoiner Books. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}